import $i18n from 'panda-i18n';
import classNames from 'classnames';
import React from 'react';
import { CnButton } from '@/components/cn-button';
import { isValidArray } from '@/utils/func';
const BottomButton = (props) => {
    const { prefix = 'cn-ui-m-', actions = ['cancel', 'ok'], size = 'large', okText, cancelText, className, okProps, cancelProps, enableSafeArea = false, showDividingLine = true, children, onOk, onCancel, ...others } = props;
    const clsPrefix = `${prefix}bottom-btn`;
    const clses = {
        bottomBtn: classNames(clsPrefix, className, {
            [`${clsPrefix}--dividing`]: showDividingLine,
            [`${clsPrefix}--safe`]: enableSafeArea,
        }),
        extra: `${clsPrefix}-extra`,
        container: classNames(`${clsPrefix}-container`, {
            [`${clsPrefix}-container--col-2`]: isValidArray(actions) && actions.length === 2,
        }),
    };
    const { text: okBtnText, ...otherOkBtnProps } = okProps || {};
    const { text: cancelBtnText, ...otherCancelBtnProps } = cancelProps || {};
    const newOkBtnText = okText ||
        okBtnText ||
        $i18n.get({ id: 'Determine', dm: '确定', ns: 'CnSelect' });
    const newCancelBtnText = cancelText ||
        cancelBtnText ||
        $i18n.get({ id: 'Cancel', dm: '取消', ns: 'CnSelect' });
    return (React.createElement("div", { ...others, className: clses.bottomBtn },
        children ? React.createElement("div", { className: clses.extra }, children) : null,
        React.createElement("div", { className: clses.container }, actions.map((act) => {
            const isCancel = act === 'cancel';
            const text = isCancel ? newCancelBtnText : newOkBtnText;
            const btnProps = {
                onClick: isCancel ? onCancel : onOk,
                size,
                ...(isCancel ? otherCancelBtnProps : otherOkBtnProps),
            };
            return (React.createElement(CnButton, { key: `bottom-btn-${act}`, type: isCancel ? 'normal' : 'primary', ...btnProps }, text));
        }))));
};
BottomButton.displayName = 'BottomButton';
export default BottomButton;
